export default __webpack_public_path__ + "static/media/model3.e182b820.png";